export const CallReceivedSituations = {
  TRANSFER: 'transferida',
  ENTERQUEUE: 'entrou_na_fila',
  COMPLETECALLER: 'complete_call',
  COMPLETEAGENT: 'complete_call',
  ABANDON: 'abandonada',
  RINGNOANSWER: 'não_atendida',
  ATTENDEDTRANSFER: 'transferida',
  BLINDTRANSFER: 'transferida',
  RINGCANCELED: 'chamada_desligada'
};
